"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNotificationContext = void 0;
var react_1 = __importStar(require("react"));
var queue_1 = require("./queue");
var queue_hooks_1 = require("./queue-hooks");
/**
 * Create a React context and hook for accessing it typed to your notification shape.
 *
 *      const { NotificationQueueProvider, useNotifications } = createNotificationContext<Notification>();
 *
 * This allows you to skip some of the ceremony needed to setup your own notification renderer.
 */
function createNotificationContext() {
    var NotificationContext = (0, react_1.createContext)(null);
    /**
     * This hook allows you to add and remove notifications from within your components.
     */
    function useNotifications() {
        var notifications = (0, react_1.useContext)(NotificationContext);
        if (!notifications) {
            throw new Error('Missing <NotificationProvider>');
        }
        return notifications;
    }
    /**
     * This component should wrap your app. It allows components to use the useNotifications hook.
     */
    function NotificationProvider(props) {
        var children = props.children;
        var queue = (0, queue_hooks_1.useImmutableQueue)();
        return react_1.default.createElement(NotificationContext.Provider, { value: queue }, children);
    }
    /**
     * Create a fake notification queue that can be used during tests and stories. Unlike the normal queue this one isn't
     * immutable, so you'll be able to inspect the state of the queue between renders:
     *
     *      const queue = createMockNotifications();
     *
     *      const { findByText } = render(
     *        <MockNotificationProvider queue={queue}>
     *          <MyComponent />
     *        </MockNotificationProvider>
     *      );
     *
     *      const el = await findByText('Submit');
     *
     *      act(() => {
     *        fireEvent.click(el);
     *      })
     *
     *      expect(queue.list.length).toBe(1);
     *      expect(queue.list[0]).toEqual({ id: 'submitting', data: { message: 'Submitting...' } });
     *
     * This will let you test that notifications are correctly firing without needing to look for elements in the DOM.
     */
    function createMockNotifications() {
        var queue = (0, queue_1.createMutableQueue)();
        function MockNotificationProvider(props) {
            var children = props.children;
            return react_1.default.createElement(NotificationContext.Provider, { value: queue }, children);
        }
        return {
            MockNotificationProvider: MockNotificationProvider,
            queue: queue,
        };
    }
    return {
        NotificationContext: NotificationContext,
        NotificationProvider: NotificationProvider,
        useNotifications: useNotifications,
        createMockNotifications: createMockNotifications,
    };
}
exports.createNotificationContext = createNotificationContext;
